import { LoadingProps } from "./types";
import { StyledLoading } from "./style";

export const Loading = ({ isLoading }: LoadingProps) => {
  return (
      <StyledLoading
        size="large"
        spinning={isLoading}
      />
  );
}